import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import persistState from "redux-localstorage";
import rootReducer from "reducers/rootReducer";
import rootSagas from "sagas/rootSaga";

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}
// Create sagas middleware
const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore(initialState: any) {
  const sagaMiddleware = createSagaMiddleware();
  const enhancer = compose(applyMiddleware(sagaMiddleware));

  let store;
  if (process.env.NODE_ENV === "production") {
    store = createStore(rootReducer, initialState, enhancer);
  } else {
    store = createStore(
      rootReducer,
      composeEnhancers(
        applyMiddleware(sagaMiddleware),
        // persistState(undefined, "auth")
      )
    );
    // Running sagas
  }
  sagaMiddleware.run(rootSagas);
  return store;
}
